module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/state/state.component.html
// module id = ./src/app/Pages/manage/state/state.component.html
// module chunks = main